import React from 'react';
import {Box} from '@mui/material';
import {Label, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './AssetPreviewModalTitle.module.scss';

function AssetPreviewModalTitle(props: {
  currentIndex: number;
  totalAssets: number;
}) {
  const {currentIndex, totalAssets} = props;
  return (
    <Box className={styles.assetPreviewModalTitleContainer}>
      <Label size="lg" color={designSystemToken('semantic.fg.inverse')}>{`${
        currentIndex + 1
      } ${translate('out-of')} ${totalAssets}`}</Label>
    </Box>
  );
}

export default AssetPreviewModalTitle;
